import { log } from "@core/services/logging/logger";

/** Root logger, see `@core/services/logging/logger`. The project / network context is added in `@ui-app/logs/archipad-context.plugin` (browser page only) */
export { log };

export const appLog = log.withPrefix("[app]");
export const syncLog = log.withPrefix("[sync]");
